/** TanStack Query keys for the agency feature — one factory, no inline literals. */
export const AGENCY_QUERY_KEYS = {
    all: ['agency'] as const,
    me: () => ['agency', 'me'] as const,
    overview: () => ['agency', 'overview'] as const,
    clients: () => ['agency', 'clients'] as const,
    pricing: () => ['agency', 'pricing'] as const,
    setups: () => ['agency', 'setups'] as const,
    branding: () => ['agency', 'branding'] as const,
    resolvedBranding: () => ['branding', 'resolved'] as const,
} as const;
